export const defaultSEO = {
  siteTitle: 'Mandir Wiki',
  title: 'Mandir Wiki – Temples in India, Darshan, Yatra & Pilgrimage Guide',
  description:
    'Explore sacred temples across India, spiritual stories, temple history, pilgrimage travel guides, locker bookings at Vaishno Devi, and virtual darshan on Mandir Wiki.',
  keywords:
    'mandir wiki, temples in india, hindu temples, pilgrimage in india, kedarnath, vaishno devi, dwarkadhish, kashi vishwanath, spiritual journeys, temple locker booking, vr darshan',
  siteUrl: 'https://www.mandir.wiki',
  ogImage: 'https://www.mandir.wiki/assets/home/logo.png',
};

export const pagesSEO = {
  home: {
    title: 'Mandir Wiki – Temples in India, Darshan, Yatra & Pilgrimage Guide',
    description:
      'Explore sacred temples across India, spiritual stories, temple history, pilgrimage travel guides, locker bookings at Vaishno Devi, and virtual darshan on Mandir Wiki.',
    canonical: 'https://www.mandir.wiki/',
    keywords: 'mandir wiki, temples in india, hindu temples, pilgrimage in india, darshan, yatra guide',
  },
  oldHome: {
    title: 'Mandir Wiki – Discover Sacred Temples & Pilgrimages in India',
    description:
      'Discover temple timings, pooja schedules, history, and pilgrimage travel guides for famous Hindu temples across India.',
    canonical: 'https://www.mandir.wiki/old',
    keywords: 'mandir wiki, india temples, hindu pilgrimage, temple timings',
  },
  vaishnoDevi: {
    title: 'Maa Vaishno Devi Temple Katra – Yatra, Darshan, Timings & Guide | Mandir Wiki',
    description:
      'Complete yatra guide to Maa Vaishno Devi Temple in Katra. Check darshan timings, aarti schedule, helicopter booking, battery car, yatra route, and locker services.',
    canonical: 'https://www.mandir.wiki/vaishno-devi',
    keywords: 'vaishno devi, vaishno devi yatra, katra, bhawan, ardhkuwari, bhairavnath, locker booking, helicopter booking',
  },
  kashiVishwanath: {
    title: 'Kashi Vishwanath Temple Varanasi – Darshan, Mangala Aarti & Timings | Mandir Wiki',
    description:
      'Detailed pilgrim guide for Kashi Vishwanath Mandir in Varanasi. Find darshan timings, Mangala Aarti booking, corridor guide, history, and how to reach.',
    canonical: 'https://www.mandir.wiki/kashi-vishwanath',
    keywords: 'kashi vishwanath, varanasi temple, banaras, jyotirlinga, mangala aarti, kashi corridor',
  },
  kedarnath: {
    title: 'Kedarnath Temple Uttarakhand – Yatra Guide, Darshan Timings & Trek | Mandir Wiki',
    description:
      'Plan your Kedarnath Dham Yatra. Check opening dates, darshan timings, pooja booking, Gaurikund to Kedarnath trek details, helicopter booking, and weather.',
    canonical: 'https://www.mandir.wiki/kedarnath',
    keywords: 'kedarnath temple, kedarnath yatra, char dham, gaurikund trek, kedarnath helicopter booking, lord shiva',
  },
  amarnath: {
    title: 'Amarnath Cave Temple – Holy Amarnath Yatra Guide & Registration | Mandir Wiki',
    description:
      'Comprehensive guide to the holy Shri Amarnath Cave Yatra. Check registration process, medical certificate requirements, Baltal & Pahalgam routes, timings, and yatra safety tips.',
    canonical: 'https://www.mandir.wiki/amarnath',
    keywords: 'amarnath temple, amarnath yatra, ice lingam, baltal route, pahalgam route, amarnath registration',
  },
  dwarkadhish: {
    title: 'Dwarkadhish Temple Dwarka – Darshan Timings, Aarti & History | Mandir Wiki',
    description:
      'Complete travel and pilgrimage guide to Jagat Mandir Shree Dwarkadhish in Gujarat. Check morning and evening aarti timings, darshan schedules, history, and festival celebrations.',
    canonical: 'https://www.mandir.wiki/dwarkadhish-temple',
    keywords: 'dwarkadhish temple, dwarka gujarat, jagat mandir, lord krishna, char dham, dwarka aarti timings',
  },
  ramanathaswamy: {
    title: 'Ramanathaswamy Temple Rameswaram – 22 Theerthams, Darshan & Timings | Mandir Wiki',
    description:
      'Pilgrimage guide to Sri Ramanathaswamy Jyotirlinga Temple in Rameswaram. Explore the 22 holy kunds (theerthams), longest pillared corridor, darshan timings, and rituals.',
    canonical: 'https://www.mandir.wiki/ramanathaswamy-temple',
    keywords: 'ramanathaswamy temple, rameswaram, 22 theerthams, jyotirlinga, agni theertham, south india pilgrimage',
  },
  ayodhya: {
    title: 'Shri Ram Janmabhoomi Mandir Ayodhya – Aarti Timings & Darshan Pass | Mandir Wiki',
    description:
      'Complete pilgrim guide for Shri Ram Janmabhoomi Mandir in Ayodhya. Know darshan timings, Mangala, Shringar and Sandhya Aarti passes, dress code, and local sightseeing in Ayodhya.',
    canonical: 'https://www.mandir.wiki/ayodhya',
    keywords: 'ram mandir ayodhya, shri ram janmabhoomi, ayodhya darshan pass, aarti timings, ram lalla',
  },
  about: {
    title: 'About Us – Preserving Indian Spiritual Heritage | Mandir Wiki',
    description:
      'Learn about Mandir Wiki, our mission to document India’s sacred temple heritage, our founders Deepak Kumar & Anand Mishra, and our vision for pilgrims worldwide.',
    canonical: 'https://www.mandir.wiki/about-us',
    keywords: 'about mandir wiki, mandir wiki founders, deepak kumar, anand mishra, spiritual tech startup',
  },
  contact: {
    title: 'Contact Us – Mandir Wiki Support & Enquiries | Mandir Wiki',
    description:
      'Get in touch with the Mandir Wiki team. Reach out for temple information, pilgrimage inquiries, locker bookings, partnerships, and customer support.',
    canonical: 'https://www.mandir.wiki/contact-us',
    keywords: 'contact mandir wiki, mandir wiki customer care, support, temple inquiry, katra locker support',
  },
  refundPolicy: {
    title: 'Refund and Cancellation Policy | Mandir Wiki',
    description:
      'Read Mandir Wiki’s refund and cancellation policies regarding locker bookings, travel packages, and online pilgrimage services.',
    canonical: 'https://www.mandir.wiki/refund-policy',
    keywords: 'mandir wiki refund policy, cancellation policy, locker refund, booking terms',
  },
  termsCondition: {
    title: 'Terms and Conditions | Mandir Wiki',
    description:
      'Read the terms and conditions governing the use of Mandir Wiki’s website, mobile app, and spiritual services.',
    canonical: 'https://www.mandir.wiki/terms-condition',
    keywords: 'terms of service, user agreement, mandir wiki terms, pilgrim services conditions',
  },
  privacyPolicy: {
    title: 'Privacy Policy | Mandir Wiki',
    description:
      'Understand how Mandir Wiki collects, uses, and safeguards your personal data and privacy when using our website and services.',
    canonical: 'https://www.mandir.wiki/privacy-policy',
    keywords: 'privacy policy, user privacy, data protection, mandir wiki privacy',
  },
  locker: {
    title: 'Safe Cloakroom & Digital Locker Booking at Katra | Mandir Wiki',
    description:
      'Book secure, digital lockers and safe cloakroom services at Katra for your Vaishno Devi Yatra. Store your luggage safely with 24/7 CCTV surveillance.',
    canonical: 'https://www.mandir.wiki/locker',
    keywords: 'locker booking katra, vaishno devi cloakroom, luggage storage katra, safe digital locker, yatra locker',
  },
  listing: {
    title: 'Explore Temples in India – State & City Wise Directory | Mandir Wiki',
    description:
      'Discover famous Hindu temples, Jyotirlingas, Shaktipeeths, and spiritual destinations across all Indian states and regions on Mandir Wiki.',
    canonical: 'https://www.mandir.wiki/listing',
    keywords: 'temples listing, india temples list, hindu temples directory, temples by state, spiritual destinations',
  },
  career: {
    title: 'Careers at Mandir Wiki – Join Our Spiritual Mission | Mandir Wiki',
    description:
      'Join the Mandir Wiki team. Explore career opportunities, internships, and full-time roles in technology, content, operations, and spiritual tourism.',
    canonical: 'https://www.mandir.wiki/career',
    keywords: 'mandir wiki careers, jobs, hiring, spiritual tech jobs, internships',
  },
  thanks: {
    title: 'Thank You | Mandir Wiki',
    description:
      'Thank you for contacting Mandir Wiki or completing your transaction. Our team will get back to you shortly.',
    canonical: 'https://www.mandir.wiki/thanks',
    keywords: 'thank you, confirmation, mandir wiki',
  },
  hotel: {
    title: 'Hotels & Dharamshalas Near Temples in India | Mandir Wiki',
    description:
      'Find and book affordable hotels, dharamshalas, and guest houses near holy temples and pilgrimage centers across India.',
    canonical: 'https://www.mandir.wiki/hotel',
    keywords: 'pilgrim hotels, temple dharamshala booking, katra hotels, varanasi stays, budget guest houses',
  },
  hotelList: {
    title: 'Pilgrim Accommodations & Hotels List | Mandir Wiki',
    description:
      'Browse top-rated hotels, ashrams, and dharamshalas near major pilgrimage shrines with verified amenities and transparent pricing.',
    canonical: 'https://www.mandir.wiki/hotel-list',
    keywords: 'hotel list, temple stays, ashram rooms, yatra hotels list, katra stays',
  },
  hotelDetail: {
    title: 'Hotel Details & Room Booking | Mandir Wiki',
    description:
      'View room types, amenities, photos, guest reviews, and pricing for hotels and stays near sacred pilgrimage sites.',
    canonical: 'https://www.mandir.wiki/hotel-detail',
    keywords: 'hotel room booking, temple hotel amenities, pilgrimage accommodation details',
  },
  hotelPayment: {
    title: 'Secure Payment – Hotel Booking | Mandir Wiki',
    description:
      'Complete your secure online payment for pilgrim hotel and dharamshala booking on Mandir Wiki.',
    canonical: 'https://www.mandir.wiki/payment',
    keywords: 'hotel payment, secure checkout, booking payment, mandir wiki payment',
  },
  vrDarshanOld: {
    title: 'Virtual Reality Darshan – Sacred 360° Temple Experience | Mandir Wiki',
    description:
      'Experience divine temple darshans from home in 360-degree immersive virtual reality with Mandir Wiki VR.',
    canonical: 'https://www.mandir.wiki/vr-darshan-old',
    keywords: 'vr darshan, 360 temple video, virtual reality darshan, online temple tour',
  },
  vrDarshanNew: {
    title: 'Virtual Darshan Hub – 360° Temple Videos & Aartis | Mandir Wiki',
    description:
      'Watch high-definition 360° VR videos of divine morning and evening aartis from renowned temples across India.',
    canonical: 'https://www.mandir.wiki/vr-darshan-new',
    keywords: 'temple aarti 360, vr darshan hub, online aarti, live mandir darshan',
  },
  vrDarshan: {
    title: 'VR Darshan & Spiritual Videos – Immersive 360° Experience | Mandir Wiki',
    description:
      'Watch trending virtual darshans, devotional immersive 360 experiences, and sacred shrine documentaries on Mandir Wiki.',
    canonical: 'https://www.mandir.wiki/vr-darshan',
    keywords: 'vr darshan, immersive spiritual video, 360 temple darshan, vr yatra',
  },
  trendingPage: {
    title: 'Trending Spiritual Content & Darshans | Mandir Wiki',
    description:
      'Explore trending temple stories, live darshan streams, and spiritual devotional videos on Mandir Wiki.',
    canonical: 'https://www.mandir.wiki/vr-darshan-extra',
    keywords: 'trending temples, spiritual videos, devotional stories, temple highlights',
  },
  trendingDetail: {
    title: 'Temple Spotlight & Trending Story | Mandir Wiki',
    description:
      'Detailed view of trending temple video, story, and spiritual darshan experience on Mandir Wiki.',
    canonical: 'https://www.mandir.wiki/trending-detail',
    keywords: 'temple video detail, trending darshan, spiritual documentary',
  },
  uploadForm: {
    title: 'Submit Temple Information & Photos | Mandir Wiki',
    description:
      'Contribute to Mandir Wiki by submitting temple details, photographs, history, or updates about sacred shrines in your region.',
    canonical: 'https://www.mandir.wiki/upload-form',
    keywords: 'submit temple, upload temple photo, mandir wiki community, add temple data',
  },
  contest: {
    title: 'Mandir Wiki Devotion Contest – Participate & Win | Mandir Wiki',
    description:
      'Participate in Mandir Wiki devotion contests, photography challenges, and quiz competitions to win exciting spiritual awards.',
    canonical: 'https://www.mandir.wiki/contest',
    keywords: 'mandir wiki contest, spiritual quiz, devotional photo competition, win awards',
  },
  vrShows: {
    title: 'Devotional VR Shows & Epics | Mandir Wiki',
    description:
      'Experience mythological and spiritual stories, epic sagas, and divine temple darshan in immersive virtual reality.',
    canonical: 'https://www.mandir.wiki/vr-shows',
    keywords: 'vr shows, devotional epics, mythological vr, 360 spiritual shows',
  },
  deviTemple: {
    title: 'Maa Durga & Devi Temples in India – Shakti Peethas Guide | Mandir Wiki',
    description:
      'Explore sacred Devi Temples and 51 Shakti Peethas across India. Learn history, significance, rituals, and festival schedules.',
    canonical: 'https://www.mandir.wiki/devi-temple',
    keywords: 'devi temple, shakti peetha, maa durga mandir, navratri temples, goddess temples in india',
  },
  vrExperience: {
    title: 'Immersive VR Temple Experience – Virtual Darshan | Mandir Wiki',
    description:
      'Feel as if you are standing in the sanctum sanctorum with our ultra-realistic 3D and 360° spiritual VR darshan experience.',
    canonical: 'https://www.mandir.wiki/vr-experience',
    keywords: 'vr temple experience, 3d darshan, virtual reality yatra, virtual pooja',
  },
  jyotirlingas: {
    title: '12 Jyotirlingas of Lord Shiva – Complete Guide & Darshan | Mandir Wiki',
    description:
      'Discover the 12 sacred Jyotirlingas of Mahadev across India, their legends, locations, darshan timings, and yatra guides.',
    canonical: 'https://www.mandir.wiki/jyotirlingas',
    keywords: '12 jyotirlingas, shiva temples, somnath, mallikarjuna, mahakaleshwar, omkareshwar, kedarnath, bhimashankar, kashi vishwanath, trimbakeshwar, vaidyanath, nageshwar, rameshwaram, grishneshwar',
  },
  comingSoon: {
    title: 'Coming Soon – Mandir Wiki Services & Mobile App | Mandir Wiki',
    description:
      'Exciting new spiritual features, yatra tools, and our upcoming mobile application are launching soon on Mandir Wiki.',
    canonical: 'https://www.mandir.wiki/coming-soon',
    keywords: 'mandir wiki app, coming soon, new pilgrimage features, samay ai, panchang',
  },
  naviStick: {
    title: 'Navi Stick – Smart Walking Stick for Pilgrims | Mandir Wiki',
    description:
      'Meet Navi Stick, an ergonomic smart pilgrimage walking stick designed to assist yatris during steep mountain climbs like Vaishno Devi and Kedarnath.',
    canonical: 'https://www.mandir.wiki/navi-stick',
    keywords: 'navi stick, pilgrim walking stick, trek support, yatra stick, elder walking assistance',
  },
  sarthiService: {
    title: 'Sarthi Yatra Assistance Service – Dedicated Pilgrim Support | Mandir Wiki',
    description:
      'Mandir Wiki Sarthi service offers dedicated on-ground guidance and assistance to ensure safe, comfortable pilgrimage for elders and families.',
    canonical: 'https://www.mandir.wiki/sarthi-service',
    keywords: 'sarthi service, pilgrim assistance, yatra guide service, elder pilgrimage help',
  },
  reuniteBand: {
    title: 'Reunite Smart Band – Child & Senior Safety at Pilgrimages | Mandir Wiki',
    description:
      'Smart identification and safety wristband preventing lost family members in crowded yatra destinations, temples, and melas.',
    canonical: 'https://www.mandir.wiki/reunite-band-service',
    keywords: 'reunite band, yatra safety, anti-lost band, pilgrim security, mela safety wristband',
  },
  yatriPack: {
    title: 'Yatri Pack – Essential Pilgrimage Kit for Travelers | Mandir Wiki',
    description:
      'All-in-one travel and wellness kit tailored for yatris covering essentials for mountain treks, temple queues, and weather shifts.',
    canonical: 'https://www.mandir.wiki/yatri-pack',
    keywords: 'yatri pack, pilgrimage kit, yatra travel essentials, trekking pack',
  },
  indiaMap: {
    title: 'Interactive India Temple Map – Find Temples by State | Mandir Wiki',
    description:
      'Explore our interactive map of India to locate historic temples, Shakti Peethas, Jyotirlingas, and holy shrines across every state.',
    canonical: 'https://www.mandir.wiki/india-map',
    keywords: 'india temple map, temples map, find temples by state, interactive pilgrim map',
  },
  vaishnoDeviPackage: {
    title: 'Vaishno Devi Yatra Tour Package – Complete Katra Tour | Mandir Wiki',
    description:
      'Book our hassle-free Vaishno Devi Yatra tour package including hotel accommodation, VIP darshan support, transfers, and locker facilities.',
    canonical: 'https://www.mandir.wiki/vaishno-devi-package',
    keywords: 'vaishno devi package, katra yatra tour, vaishno devi tour package, darshan package',
  },
  varanasiPackage: {
    title: 'Varanasi Kashi Tour Package – Ganga Aarti & Temple Darshan | Mandir Wiki',
    description:
      'Complete spiritual tour package of Varanasi covering Kashi Vishwanath darshan, sunrise boat ride, Dashashwamedh Ghat evening Ganga Aarti, and Sarnath excursion.',
    canonical: 'https://www.mandir.wiki/varanasi-package',
    keywords: 'varanasi package, kashi vishwanath tour, ganga aarti tour, banaras tour package',
  },
  packageListing: {
    title: 'Pilgrimage Tour Packages & Yatra Bookings | Mandir Wiki',
    description:
      'Browse curated devotional pilgrimage tour packages across India: Vaishno Devi, Varanasi, Char Dham, Jyotirlingas, and South India temple circuits.',
    canonical: 'https://www.mandir.wiki/packages',
    keywords: 'pilgrimage packages, yatra tour packages, temple travel packages, char dham package',
  },
  blogListing: {
    title: 'Spiritual Blogs, Hindu Mythology & Temple Guides | Mandir Wiki',
    description:
      'Read inspiring blogs, religious festival dates, puja vidhi, temple histories, and yatra travel tips on Mandir Wiki.',
    canonical: 'https://www.mandir.wiki/blog',
    keywords: 'mandir wiki blogs, spiritual articles, hindu festivals, temple history blogs, puja vidhi',
  },
  blogAnantChaturdashi: {
    title: 'Anant Chaturdashi & Ganesh Visarjan: Shubh Muhurat, Timings & Vidhi | Mandir Wiki',
    description:
      'Comprehensive guide to Anant Chaturdashi and Ganesh Visarjan: auspicious puja muhurat, visarjan timings, sacred rituals, and iconic immersion ghats.',
    canonical: 'https://www.mandir.wiki/blog/anant-chaturdashi-ganesh-visarjan',
    keywords: 'anant chaturdashi, ganesh visarjan, visarjan muhurat, anant sutra vidhi, ganesh utsav',
  },
  blogKedarnath: {
    title: 'Kedarnath Temple History & The Pandava Story | Mandir Wiki',
    description:
      'Discover the legendary history of Kedarnath Temple, the Mahabharata Pandava story, Adi Shankaracharya’s samadhi, and the sacred bull hump myth.',
    canonical: 'https://www.mandir.wiki/blog/kedarnath-temple-history-and-pandava-story',
    keywords: 'kedarnath history, pandava story kedarnath, adi shankaracharya, kedarnath shivling, char dham history',
  },
  blogPitruPaksha: {
    title: 'Pitru Paksha: Significance of Feeding Crows & Shradh Puja Vidhi | Mandir Wiki',
    description:
      'Learn why feeding crows (Kagbhaas) is essential during Pitru Paksha, the legend of Kakbhushundi, Tarpan rules, and complete Shradh puja vidhi.',
    canonical: 'https://www.mandir.wiki/blog/pitru-paksha-crow-significance-shradh-puja-vidhi',
    keywords: 'pitru paksha, feeding crows in shradh, kagbhaas, kakbhushundi, tarpan vidhi, shradh rituals',
  },
  blogVaishnoDevi: {
    title: 'Maa Vaishno Devi Story: Pandit Shridhar & Bhairavnath Legend | Mandir Wiki',
    description:
      'Read the sacred legend of Mata Vaishno Devi, Pandit Shridhar’s Bhandara, Bhairavnath’s salvation, and the divine secret of the Trikuta cave.',
    canonical: 'https://www.mandir.wiki/blog/vaishno-devi-story-shridhar-bhairavnath',
    keywords: 'vaishno devi story, pandit shridhar bhandara, bhairavnath legend, trikuta parvat, maa vaishno history',
  },
  notFound: {
    title: 'Page Not Found (404) – Mandir Wiki',
    description:
      'The page you are looking for does not exist on Mandir Wiki. Return to home or explore famous Indian temples and pilgrimage guides.',
    canonical: 'https://www.mandir.wiki/404',
    keywords: '404 not found, mandir wiki error page',
  },
};
